import { CircularProgress, Stack } from '@mui/material';

export function Loader() {
  return (
    <Stack
      height="100%"
      width="100%"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress data-testid="table-loader" />
    </Stack>
  );
}
